import licitacao from './LicitacaoApiClient'

export default {
    licitacao,
}
